/**
 * Available tabs in the drawing widget.
 */
export enum DrawingTabEnum {
  MODIFY_PREDEFINED_SHAPE_TAB = 'MODIFY_PREDEFINED_SHAPE_TAB',
  FREE_DRAWING_TAB = 'FREE_DRAWING_TAB',
  /**
   * For any tab that belongs to a shape. This is not one tab but the symbol for any shape tab.
   */
  SELECTED_SHAPE_TAB = 'SELECTED_SHAPE_TAB',
  QUICK_ESTIMATE_TAB = 'QUICK_ESTIMATE_TAB',
}
